import React from "react";
import Landing_page from "../Landing_page/Landing_page";

import Buy_Section from "../Buy_Section/Buy_Section";
import Roadmap from "../Timelinenew/Timeline";


import FAQ from "../FAQ/FAQ";
import Ecosystem from "../Ecosystem/Ecosystem";

import Tokenomics from "../Tokenomics/Tokenomics";

export default function Home_page() {
  return (
    <div>
      <Landing_page />
      <Ecosystem></Ecosystem>
      <Tokenomics></Tokenomics>

      <Roadmap />


      <Buy_Section />

      <FAQ />
    </div>
  );
}
